// extracted by mini-css-extract-plugin
module.exports = {"box":"DialogLottery_box_3IaaQ","content":"DialogLottery_content_1gucz","enter":"DialogLottery_enter_2TLq4"};